/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.12",
    versionName: "0.2.0-nightly.2026.3.12",
    versionChannel: "nightly",
    buildDate: "2026-03-12T00:12:04.238Z",
    commitHash: "cff516dae6f92402cd1d4a6d3a702b53e668b90e",
};
